// ResponsiveAppBarStyles.js

const appBarStyles = {
    // background: '#0D8B5A',
    background: 'linear-gradient(270deg, #12CE85 -30.5%, #0D8B5A 130.5%)',
    pl: { xs: 0, md: 18 },
    pe: { xs: 0, md: 6 },
    boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.1)', // Light shadow for a subtle effect
  };
  
  const logoStyles = {
    height: 40,
    display: { xs: 'none', md: 'flex' },
    mr: 1,
  };
  
  const logoMobileStyles = {
    height: 40,
    display: { xs: 'flex', md: 'none' },
    mr: 1,
  };
  
  const titleStyles = {
    // mr: 1,
    display: { xs: 'none', md: 'flex' },
    fontFamily: 'Century Gothic',
    fontWeight: 600,
    letterSpacing: '.1rem',
    color: '#FFFFFF',
    textDecoration: 'none',
  };
  
  const titleMobileStyles = {
    mr: 2,
    display: { xxxs: 'none', md: 'none' }, // xs pe none aur md pe flex
    flexGrow: 1,
    fontFamily: 'Century Gothic',
    fontWeight: 700,
    letterSpacing: '.3rem',
    color: '#FFFFFF',
    textDecoration: 'none',
  };
  
  const buttonStyles = {
    my: 2,
    mx: 2,
    fontFamily: 'Poppins, Arial, sans-serif',
    letterSpacing: '.1rem',
    color: 'white',
    display: 'block',
    textTransform: 'none'
  };
  
  const underlineStyles = {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    height: '4px',
    width: '100%',
    backgroundColor: '#50DEF2',
  };
  
  export {
    appBarStyles,
    logoStyles,
    logoMobileStyles,
    titleStyles,
    titleMobileStyles,
    buttonStyles,
    underlineStyles,
  };
  